<template>
  <div>
    <el-select
      ref="select"
      :value="value"
      :placeholder="placeholder"
      :size="size"
      :filterable="filterable"
      :clearable="clearable"
      :disabled="disabled"
      :multiple="multiple"
      @change="change($event)"
      :style="vstyle"
      :class="vclass"
    >
      <slot :options="optionData">
        <el-option
          v-for="item in optionData"
          :key="options.value === 'this' ? item.value.value : item.value"
          :label="item.label"
          :value="item.value"
        />
      </slot>

      <template #empty>
        <slot name="empty" />
      </template>
    </el-select>
  </div>
</template>

<script>
import { request } from '@/api/service'

export default {
  name: 'dict-select',
  data() {
    return {
      optionData: [],
      svalue: '',
      selected: {},
    }
  },
  computed: {
    optionsMap() {
      return Object.fromEntries(this.optionData.map((o) => [o.value, o]))
    },
  },
  methods: {
    change: function(val) {
      this.$emit('input', val)
      this.$emit('change', val)
      this.$emit(
        'update:selectedLabel',
        this.optionsMap[val] ? this.optionsMap[val].label : ''
      )
      let selected = this.optionData.filter((item) => item.value === val)
      this.selected = selected && selected.length > 0 ? selected[0] : ''
    },
    init() {
      if (!this.url) return
      // 初始话下拉框的值
      this.svalue = this.value
      // 远程请求回来的数据
      request({
        url: this.url,
        method: this.methods,
        data: this.body,
        params: this.params,
      }).then((res) => {
        this.optionData = this._dataTransform(res.body.data)
        this.$emit('loaded', this.optionData)
      })
    },
    // 转换下拉框下的字段
    _dataTransform(data) {
      if (!this.options) {
        return data
      }
      let _data = data.map((t) => {
        const { label, value } = this.options
        return {
          ...t,
          label: t[label || 'label'],
          value: value === 'this' ? t : t[value],
        }
      })
      return _data || []
    },
  },
  watch: {
    // 判断下拉框的值是否有改变
    svalue(val, oldVal) {
      if (val !== oldVal) {
        this.$emit('input', this.svalue)
      }
    },
    body(val) {
      if (val) {
        this.init()
      }
    },
    url(val) {
      if (val) {
        this.init()
      }
    },
  },
  props: {
    placeholder: {
      default: 'Please select',
      type: String,
    },
    size: {
      default: 'small',
      type: String,
    },
    vstyle: {
      default: 'width:100%;',
      type: String,
    },
    vclass: {
      default: '',
      type: String,
    },
    filterable: {
      default: false,
      type: Boolean,
    },
    clearable: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    multiple: {
      default: false,
      type: Boolean,
    },
    url: {
      default: '/master/common/dict/system',
      type: String,
    },
    value: {}, // 接受外部v-model传入的值，要支持多选，不能指定字段类型和默认值
    selectedLabel: String,
    options: {
      type: Object,
      default: () => {
        return { label: 'label', value: 'value' }
      },
    }, // 定义请求回来的json数据格式
    body: {
      type: Object,
    },
    params: {
      type: Object,
    },
    methods: {
      type: String,
      default: 'POST',
    },
  },
  mounted() {
    this.init()
  },
}
</script>
